module.exports = "/_next/static/images/illustartion2-f4fc4cef48acf9c95b4c7750451493fa.svg";